import { gql } from '__generated__'

export const GetCandidatesByName = gql(/* GraphQL */ `
    query GetCandidatesByName($name: String, $page: Int, $limit: Int) {
        candidatesByName(name: $name, page: $page, limit: $limit) {
            data {
                id
                user {
                    firstName
                    lastName
                    nickname
                    email
                }
                currentWorkExperience {
                    company {
                        value
                    }
                }
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetCandidatesByIds = gql(/* GraphQL */ `
    query GetCandidatesByIds($ids: [ID!]!) {
        candidatesById(ids: $ids) {
            id
            user {
                firstName
                lastName
                nickname
            }
        }
    }
`)
